<div class="cf-google-button" (click)="connectGoogleCalendar()">
  <div class="m-auto d-flex flex-col align-items-center">
    <cf-icon size="md" [icon]="icon"></cf-icon>
    <ng-content></ng-content>
  </div>
</div>
